import React, { useState } from 'react';
import './input.scss';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import { Link } from 'react-router-dom';
import { ChildInput, useStyles } from './reusableInput.style';
import { InputState, ReusableInputs, PlainInputs } from './Types';

export const PlainInput = ({
	name,
	placeholder,
	type,
	link,
	width,
	height,
	beforeLinkText,
	textLink,
	defaultValue,
	fvalue,
	label,
	onChange,
	childId,
	required,
}: PlainInputs) => {
	// eslint-disable-next-line no-console
	console.log(defaultValue);
	const classes = useStyles({ width, height });
	const [values, setValues] = useState<InputState>({
		showPassword: false,
	});

	const handleClickShowPassword = () => {
		setValues({ ...values, showPassword: !values.showPassword });
	};

	const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
		event.preventDefault();
	};
	const handleChange = (e: any) => {
		// eslint-disable-next-line no-console
		console.log(e.target.value, e.target.name);
		onChange && onChange(e.target.value, childId);
	};
	return (
		<FormControl className={classes.margin}>
			<InputLabel shrink htmlFor="input" className={`${classes.label} px-4`}>
				{label}
			</InputLabel>
			<ChildInput
				onChange={handleChange}
				placeholder={placeholder}
				fullWidth
				autoComplete={
					type === 'password'
						? values.showPassword
							? 'current-text'
							: 'current-password'
						: `current-${type}`
				}
				className={classes.inputs}
				name={name || defaultValue}
				// value={fvalue}
				defaultValue={defaultValue}
				type={type === 'password' ? (values.showPassword ? 'text' : 'password') : type}
				id="input"
				required={required}
				endAdornment={
					<InputAdornment position="start" className={classes.display}>
						{name === 'password' && (
							<IconButton
								aria-label="toggle password visibility"
								onClick={handleClickShowPassword}
								onMouseDown={handleMouseDownPassword}
								size="small"
							>
								{values.showPassword ? <Visibility /> : <VisibilityOff />}
							</IconButton>
						)}
					</InputAdornment>
				}
			/>
			<div className="d-inline">
				{/* <small className="px-4 text-danger float-start">
					{formik?.touched[name] && formik?.errors[name]}
				</small> */}
				<div>
					{beforeLinkText && <small className="float-end text-primary">{beforeLinkText}</small>}
					{link && (
						// <Link to={link} className={classes.link}>
						<div
							className={classes.link}
							style={{ cursor: 'pointer' }}
							onClick={() => window.open(link, '_self')}
						>
							<small className="float-end">{textLink}</small>
						</div>

						// </Link>
					)}
				</div>
			</div>
		</FormControl>
	);
};
